<app-header-one [class]="'header-gym'"></app-header-one>

<section class="section-b-space pt-0">
    <div class="container">
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3">
                <h2 class="my-5 d-none d-md-block">Il tuo ordine</h2>
                <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="'Checkout'"></app-navigation-bar></div>
            </div>
            <div class="col-xl-9 col-lg-9 col-md-9 mt-5">
                <div class="row mt-5">
                    <div class="col-xl-6 col-sm-12 col-12">
                        <div class="checkout-page" *ngIf="cartData && cartData.order">
                            <div class="checkout-title m-0 d-sm-block">
                                <!--h3 class="text-uppercase" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO">Conferma i dati per la consegna</h3>
                                <h3 class="text-uppercase" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">Conferma i dati per il ritiro</h3-->
                                <h3>Conferma i tuoi dati</h3>
                            </div>
                            <div class="checkout-form py-3">
                                <form>
                                    <div class="check-out mt-4"
                                        *ngIf="cartData.order.type_order==typeOrder.REST_DOMICILIO"> <!--location && -->
                                        <h4 class="title title-lime">Indirizzo di consegna</h4>
                                        <div class="media location-card border-product" (click)="editLocation()">
                                            <div class="media-body align-self-center"
                                                *ngIf="cartData.order && cartData.order.location.address">
                                                <h6 class="product-title">
                                                    {{ cartData.order.location.address }}, {{
                                                    cartData.order.location.num }}<br>
                                                    {{ cartData.order.location.townstr }}, {{
                                                    cartData.order.location.zip }}
                                                </h6>
                                                <img class="img-fluid w-auto" src="assets/images/Icone/casa.png" alt="">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row check-out">
                                        <div class="col-md-12 col-sm-12 col-xs-12">

                                            <div class="media border-product eit-field">

                                                <div class="media-body align-self-center mb-2">

                                                    <input type="text" name="phone"
                                                        [formControl]="checkoutForm.controls['phone']" value=""
                                                        placeholder="" autocomplete="off"
                                                        placeholder="Indicaci il telefono di chi sta ordinando">

                                                    <img *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required"
                                                        class="img-fluid w-auto" src="assets/images/Icone/info.png"
                                                        alt="">
                                                    <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required"
                                                        class="text text-danger">
                                                        Telefono richiesto.
                                                    </div>
                                                    <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.pattern"
                                                        class="text text-danger d-inline-block">
                                                        Il Telefono deve essere un numero.
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="row check-out"
                                        *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO">

                                        <div class="form-group col-md-12 col-sm-12 col-xs-12 ">
                                            <div class="media border-product eit-field">
                                                <div class="media-body align-self-center mb-2">
                                                    <input type="text" name="citofono"
                                                        [formControl]="checkoutForm.controls['citofono']" value=""
                                                        placeholder="" autocomplete="off" placeholder="Citofono">
                                                    <img *ngIf="checkoutForm.controls.citofono.touched && checkoutForm.controls.citofono.errors?.required"
                                                        class="img-fluid w-auto" src="assets/images/Icone/info.png"
                                                        alt="">
                                                    <div *ngIf="checkoutForm.controls.citofono.touched && checkoutForm.controls.citofono.errors?.required"
                                                        class="text text-danger d-inline-block">
                                                        Citofono richiesto.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--<div class="form-group col-md-6 col-sm-6 col-xs-12">
                                            <div class="media border-product">
                                                <div class="media-body align-self-center ">
                                                    <input type="text" name="interno" [formControl]="checkoutForm.controls['interno']" value="" placeholder=""
                                                        autocomplete="off" placeholder="Interno o scala">
                                                </div>
                                            </div>
                                        </div>-->
                                        <!--div class="form-group col-md-12 col-sm-12 col-xs-12">
                                            <textarea rows="3" name="note" [formControl]="checkoutForm.controls['note']"
                                                value="" placeholder="" autocomplete="off" placeholder="Note per il ristorante">
                                            </textarea>
                                        </div-->
                                        <div class="form-group col-md-12 col-sm-12 col-xs-12">

                                            <textarea rows="3" name="noteride"
                                                [formControl]="checkoutForm.controls['noteride']" value=""
                                                placeholder="" autocomplete="off"
                                                placeholder="Segnalaci in questo campo eventuali note per il Rider">
                                            </textarea>
                                        </div>

                                    </div>
                                    <!--div class="row check-out" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">

                                        <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                            <textarea rows="3" name="note" [formControl]="checkoutForm.controls['note']"
                                                value="" placeholder="" autocomplete="off" placeholder="Note per il ristorante">
                                            </textarea>
                                        </div>

                                    </div-->

                                </form>
                                <div class="row margin-cls">
                                    <div class="col-12 d-flex justify-content-end">
                                        <button class="button-primary-text button-fill-rounded" (click)="goToPay()">
                                            Vai al pagamento
                                            <img src="assets/icons/freccia.svg">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-sm-12 col-12 d-none d-md-block">
                        <app-cart-box (notifyCheck)="onNotify($event)" [showCoupon]="false" [editable]="false"
                            [loader]="false" [restaurant]="restaurant">
                        </app-cart-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- 
<section class="total-section fixed-b py-4 px-3 d-block d-md-none" *ngIf="cartData">
    <div class="media mx-3 d-flex justify-content-between"
        *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
        <div class="media-body align-self-top">
            <p class="product-title m-0 total-title text-start">Totale</p>
        </div>
        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
            {{cartData.order.euro_total.toFixed(2)}} &euro;
        </p>
        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
            {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
        </p>
    </div>

    <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
        <div class="media-body align-self-top">
            <p class="product-title m-0 total-title text-start">Totale</p>
        </div>

        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
            {{cartData.order.euro_total.toFixed(2)}} &euro;
        </p>
        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
            {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
        </p>
    </div>
</section> -->
<section class="total-section py-4 px-3 d-block d-md-none" *ngIf="cartData">
    <div class="media mx-3 d-flex justify-content-between"
        *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
        <div class="media-body align-self-top">
            <p class="product-title m-0 total-title text-start">Totale</p>
        </div>
        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
            {{cartData.order.euro_total.toFixed(2)}} &euro;
        </p>
        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
            {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
        </p>
    </div>

    <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
        <div class="media-body align-self-top">
            <p class="product-title m-0 total-title text-start">Totale</p>
        </div>

        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
            {{cartData.order.euro_total.toFixed(2)}} &euro;
        </p>
        <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
            {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
        </p>
    </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>